export const AUTH_ERROR = "AUTH_ERROR";

export const GET_ERRORS = "GET_ERRORS";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const CLINIC_LOADING = "CLINIC_LOADING";
export const CLINIC_LOADED = "CLINIC_LOADED";
export const CLINIC_LOADING_ERROR = "CLINIC_LOADING_ERROR";
